import React, { useEffect, useState } from "react";
import moment, { Moment } from "moment";
import { TimeRangePicker } from "@sonder/ui/source/styled/components/TimeRangePicker";
import { Label } from "@sonder/ui/source/styled/fragments/Label";

interface PreferredTimeWindowProps {
  onChange: (date: string, isBelowThreshold: boolean) => void;
}

const MINIMUM_THRESHOLD_HOURS = 2;

export const PreferredTimeWindow = ({ onChange }: PreferredTimeWindowProps) => {
  const [startDate, setStartDate] = useState<moment.Moment | undefined>(
    undefined,
  );
  const [endDate, setEndDate] = useState<moment.Moment | undefined>(undefined);

  const timeThreshold =
    startDate && endDate
      ? moment.duration((endDate as Moment).diff(startDate as Moment)).asHours()
      : null;

  const isBelowThreshold = Boolean(
    timeThreshold && timeThreshold < MINIMUM_THRESHOLD_HOURS,
  );

  useEffect(() => {
    if (startDate && endDate) {
      const formattedStartDate = moment(startDate).format("HH:mm");
      const formattedEndDate = moment(endDate).format("HH:mm");
      const date = `${formattedStartDate}-${formattedEndDate}`;
      onChange(date, isBelowThreshold);
    }
  }, [startDate, endDate]);

  return (
    <>
      <TimeRangePicker
        endDate={endDate}
        startDate={startDate}
        onChangeEndDate={date => setEndDate(date)}
        onChangeStartDate={date => setStartDate(date)}
      />
      {isBelowThreshold && (
        <Label error> Time must be greater than 2 hours </Label>
      )}
    </>
  );
};
